import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { OutOfOfficeModel } from '@smarttask-common/src/lib/models/Resource/OutOfOfficeModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class OutOfOfficeHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.out_of_office_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.out_of_office_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.out_of_office_upsert, (model: OutOfOfficeModel) => {
            this.broadcast(SharedEventNameEnum.out_of_office_upsert, { model });
        });

        this.on(SharedEventNameEnum.out_of_office_delete, (ooo_uuid: string) => {
            this.broadcast(SharedEventNameEnum.out_of_office_delete, { ooo_uuid });
        });
    };
}
